import { render, staticRenderFns } from "./DeleteActivityDialog.vue?vue&type=template&id=6e67704d&scoped=true&"
import script from "./DeleteActivityDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteActivityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67704d",
  null
  
)

export default component.exports